import { sbxCoreService} from '../Network';
import City from '../Models/City';
import Zone from '../Models/Zone';
import {isPresent} from "../Utils/Utils";
import {SearchCityParams} from "../Models/SearchCityParams";
import Region from "../Models/Region";

const MODEL = "city";

export function getCities(filters?: SearchCityParams) {
  let query = sbxCoreService.with(MODEL)

  if(isPresent(filters)){
    query.newGroupWithAnd();
  }

  if(filters?.name) {
    query.orWhereItContains('name', filters.name);
  }

  if(filters?.allow_city) {
    query.orWhereItContains('allow_city',`${filters.allow_city}` );
  }

  return query.loadAll()
}

export function getCitiesByRegion(region: Region) {
  return sbxCoreService.with("region_city")
    .andWhereIsEqualTo("region", region._KEY)
    .fetchModels([MODEL, "region"])
    .loadAll()
}

export const deleteCity = (cityKey:string) => {
  return sbxCoreService.with('city')
    .whereWithKeys([cityKey])
    .delete();
};

export const deleteZones = (cityKey:string) => {
  return sbxCoreService.with('zone')
    .andWhereIsEqualTo('city', cityKey)
    .delete();
};

export const deleteRegionCities = (cityKey:string) => {
  return sbxCoreService.with('region_city')
    .andWhereIsEqualTo('city', cityKey)
    .delete();
};


export const saveCity = (city: City) =>{
  if(!city._KEY){
    return sbxCoreService.with('city')
      .insert(city);
  }else{
    return sbxCoreService.with('city')
      .whereWithKeys([city._KEY])
      .update(city);
  }
};

export const getZonesPerCity = (cityKey:string) =>{
  return sbxCoreService.with('zone')
    .andWhereIsEqualTo('city', cityKey)
    .loadAll();
};

export const deleteZoneInCity = (zoneKey:string) =>{
  return sbxCoreService.with('zone')
    .whereWithKeys(zoneKey)
    .delete()
};


export const insertZone = (zone:Zone) =>{
  return sbxCoreService.insert('zone', zone);
};

export const getCityByKey = (key: string) => {
  return sbxCoreService.with(MODEL).whereWithKeys([key]).loadAll();
}
